(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["school-select-popup"] && !Shopify.designMode) return;
  try {
    class SchoolSelectPopup extends HTMLElement {
    constructor() {
      super();
      this.closeButton = this.querySelector('.school-select-popup__close-button');
      this.schoolInput = this.querySelector('#schoolsearch_input');
      this.errorLabel = this.querySelector('#error_school');
      this.schoolList = this.querySelector('.cart_schoollist ul');
      this.schoolListContainer = this.querySelector('.cart_schoollist');
      this.searchMessage = this.querySelector('.searchmessage');
      this.debounceTimeout = null;

      this.closeButton.addEventListener('click', () => this.closePopup());
      this.schoolInput.addEventListener('input', (event) => this.handleInput(event));

      this.querySelector('.private-person')?.addEventListener('click', () => {
        window.dispatchEvent(
          new CustomEvent('widget::school_selected', {
            detail: {
              schoolId: '0',
            },
          })
        );
        this.closePopup();
      });

      this.addEventListener('click', (event) => {
        console.log('Clicked element:', event.target.dataset);
        if (event.target === 'a' || event.target.closest('a')) {
          LiveChatWidget.call('set_session_variables', {
            school_id: event.target.dataset.listSchoolid,
            school_name: event.target.dataset.listSchool,
          });
          window.dispatchEvent(
            new CustomEvent('widget::school_selected', {
              detail: {
                schoolId: event.target.dataset.listSchoolid,
                schoolName: event.target.dataset.listSchool,
              },
            })
          );
          this.closePopup();
        }
      });
    }

    connectedCallback() {}

    showPopup() {
      this.style.display = 'flex';
    }

    closePopup() {
      this.style.display = 'none';
    }

    handleInput(event) {
      const { value } = event.target;
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => this.schoolFinder(value), 1000);
    }

    schoolFinder(query) {
      const minCharacters = 3;

      this.searchMessage.textContent = 'Söker efter skolan';

      if (query.length < minCharacters) {
        this.searchMessage.style.display = 'none';
        this.clearSchoolList();
        return;
      }

      this.clearSchoolList();
      this.searchMessage.style.display = '';
      this.schoolListContainer.style.display = '';

      fetch(`https://majema-free-copy-82691fc887b8a8bad1eb.o2.myshopify.dev/get-schools-list?q=${encodeURIComponent(query)}`)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((results) => {
          if (Array.isArray(results)) {
            results.slice(0, 6).forEach((element) => {
              const listItem = document.createElement('li');
              const anchor = document.createElement('a');
              const primaryAddress = element.street_address_1 ?? element.street_address ?? '';
              const secondaryAddress = element.street_address ?? '';

              anchor.className = 'schoolelement';
              anchor.dataset.listKundenr = element.kundnr ?? '';
              anchor.dataset.listSchoolid = element.id ?? '';
              anchor.dataset.listSchool = element.company ?? '';
              anchor.dataset.listAddress1 = primaryAddress;
              anchor.dataset.listAddress2 = secondaryAddress;
              anchor.dataset.addressPostcode = element.postal_code ?? '';
              anchor.dataset.addressCity = element.postal_address ?? '';
              anchor.dataset.countryCode = element.postal_country ?? '';

              anchor.innerHTML = `
                ${element.company ?? ''}
                <br>${primaryAddress}
                ${secondaryAddress ? `<br>${secondaryAddress}` : ''}
                <br>${element.postal_code ?? ''}
                <br>${element.postal_address ?? ''}
              `;

              listItem.appendChild(anchor);
              this.schoolList.appendChild(listItem);
            });

            if (results.length > 0) {
              this.searchMessage.innerHTML =
                'Vänligen skriv in skolans namn och <strong>klicka på skolans namn nedan</strong> för att komma vidare.';
            }

            if (results.length === 0) {
              this.appendMessageListItem(
                'Vi hittar tyvärr inte skolan - vänligen skriv minst sex bokstäver i skolans namn och prova igen.'
              );
              this.searchMessage.style.display = 'none';
            }
          }
        })
        .catch(() => {
          this.appendMessageListItem('An error occurred. Please try again.');
        });
    }

    clearSchoolList() {
      this.schoolList.innerHTML = '';
      this.schoolList.textContent = this.schoolList.textContent.trim();
    }

    appendMessageListItem(message) {
      const listItem = document.createElement('li');
      listItem.textContent = message;
      this.schoolList.appendChild(listItem);
    }
  }

  customElements.define('school-select-popup', SchoolSelectPopup);
  } catch(e) { console.error(e); }
})();

})();
